const hane = (n) => `${n} hane`;
/**
 * Cep telefonu. Kabul edilen yazımlar:
 *   0532 123 45 67 · 532 123 45 67 · +90 532 123 45 67 · 90 532… · 0090 532…   → +905321234567
 *   +49 151 2345 6789 · 0049 151…  (yurt dışı: ülke kodu "+" ya da "00" ile ŞART)   → +4915123456789
 * Türkiye numarası cep (5xx) olmalıdır: SMS ve WhatsApp sabit hatta gitmez.
 */
export function telefonDenetle(ham) {
    const metin = String(ham ?? '').trim();
    if (!metin)
        return { ok: false, neden: 'Telefon numarası yazın.' };
    if (/[a-zA-ZçğıöşüÇĞİÖŞÜ]/.test(metin))
        return { ok: false, neden: 'Telefon numarasında harf olamaz; yalnız rakam yazın.' };
    if (/[/,;|]/.test(metin))
        return { ok: false, neden: 'Tek bir numara yazın (birden çok numara ya da dahili yazılamaz).' };
    if (/[^\d\s()+.\-]/.test(metin))
        return { ok: false, neden: 'Telefon numarasında yalnız rakam, boşluk ve baştaki "+" olabilir.' };
    if (metin.indexOf('+') > 0 || metin.split('+').length > 2)
        return { ok: false, neden: '"+" işareti yalnız numaranın en başında olabilir.' };
    const arti = metin.startsWith('+');
    let n = metin.replace(/\D/g, '');
    const sifirSifir = !arti && n.startsWith('00');
    if (sifirSifir)
        n = n.slice(2);
    if (!n)
        return { ok: false, neden: 'Telefon numarası yazın.' };
    // Ülke kodu açıkça yazılmış ve Türkiye değil → yurt dışı numarası.
    if ((arti || sifirSifir) && !n.startsWith('90')) {
        if (n.startsWith('0'))
            return { ok: false, neden: 'Ülke kodu 0 ile başlayamaz (örnek: +49 151 2345 6789).' };
        if (n.length < 8)
            return { ok: false, neden: `Numara eksik: ülke koduyla birlikte en az 8 hane olmalı (${hane(n.length)} yazıldı).` };
        if (n.length > 15)
            return { ok: false, neden: `Numara fazla uzun: ülke koduyla birlikte en çok 15 hane olabilir (${hane(n.length)} yazıldı).` };
        return { ok: true, deger: `+${n}`, goster: `+${n}` };
    }
    // Türkiye: ülke kodunu ve baştaki 0'ı at, geriye 10 haneli abone numarası kalmalı.
    let abone = n;
    if (arti || sifirSifir)
        abone = n.slice(2); // +90… / 0090…
    else if (n.startsWith('90') && n.length === 12)
        abone = n.slice(2); // 90 532…
    else if (n.startsWith('0'))
        abone = n.slice(1); // 0532…
    if (abone.startsWith('0'))
        abone = abone.slice(1); // +90 0532… (sık yapılan hata)
    if (abone.length < 10) {
        const eksik = 10 - abone.length;
        return { ok: false, neden: `Numara eksik: ${eksik} hane daha gerekli. Örnek: 0532 123 45 67` };
    }
    if (abone.length > 10) {
        return { ok: false, neden: `Numara fazla uzun: ${abone.length - 10} hane fazla. Yurt dışı numarasıysa ülke kodunu "+" ile yazın (örnek: +49 151 2345 6789).` };
    }
    if (!abone.startsWith('5')) {
        return { ok: false, neden: `Bu bir sabit hat (alan kodu ${abone.slice(0, 3)}). SMS ve WhatsApp için 5 ile başlayan cep numarası gerekli.` };
    }
    if (/^5(\d)\1{8}$/.test(abone))
        return { ok: false, neden: 'Bu numara gerçek görünmüyor (aynı rakam tekrar ediyor).' };
    return {
        ok: true, deger: `+90${abone}`,
        goster: `+90 ${abone.slice(0, 3)} ${abone.slice(3, 6)} ${abone.slice(6, 8)} ${abone.slice(8)}`,
    };
}
/** Sık yapılan alan adı yazım hataları → doğrusu. Yalnız kesin hatalar; gerçek bir alan adı buraya yazılmaz. */
const ALAN_DUZELT = {
    'gmial.com': 'gmail.com', 'gmai.com': 'gmail.com', 'gmal.com': 'gmail.com', 'gmil.com': 'gmail.com', 'gmaill.com': 'gmail.com',
    'gnail.com': 'gmail.com', 'gmail.co': 'gmail.com', 'gmail.con': 'gmail.com', 'gmail.cm': 'gmail.com', 'gmail.om': 'gmail.com', 'gmail.comm': 'gmail.com',
    'hotmial.com': 'hotmail.com', 'hotmai.com': 'hotmail.com', 'hotmal.com': 'hotmail.com', 'hotmil.com': 'hotmail.com', 'hotmaill.com': 'hotmail.com',
    'hotmail.co': 'hotmail.com', 'hotmail.con': 'hotmail.com', 'hotmail.cm': 'hotmail.com',
    'outlok.com': 'outlook.com', 'outloo.com': 'outlook.com', 'outlook.co': 'outlook.com', 'outlook.con': 'outlook.com',
    'yaho.com': 'yahoo.com', 'yahooo.com': 'yahoo.com', 'yahoo.co': 'yahoo.com', 'yahoo.con': 'yahoo.com',
    'icloud.co': 'icloud.com', 'icloud.con': 'icloud.com', 'iclod.com': 'icloud.com',
};
const TR_HARF = { ç: 'c', ğ: 'g', ı: 'i', ö: 'o', ş: 's', ü: 'u', Ç: 'c', Ğ: 'g', İ: 'i', Ö: 'o', Ş: 's', Ü: 'u' };
/**
 * E-posta adresi. Tek adres; boşluk, Türkçe karakter ve ikinci "@" kabul edilmez.
 * Kayda küçük harfle girer. Bilinen yazım hatasında (gmial.com gibi) doğrusu `oneri` olarak döner.
 */
export function epostaDenetle(ham) {
    const metin = String(ham ?? '').trim();
    if (!metin)
        return { ok: false, neden: 'E-posta adresi yazın.' };
    if (/[,;]/.test(metin))
        return { ok: false, neden: 'Tek bir e-posta adresi yazın.' };
    if (/\s/.test(metin))
        return { ok: false, neden: 'E-posta adresinde boşluk olamaz.', oneri: metin.replace(/\s+/g, '') };
    const turkce = [...metin].filter((h) => h in TR_HARF);
    if (turkce.length) {
        return {
            ok: false, neden: `E-posta adresinde Türkçe karakter olamaz: ${[...new Set(turkce)].join(' ')}`,
            oneri: [...metin].map((h) => TR_HARF[h] ?? h).join('').toLowerCase(),
        };
    }
    // eslint-disable-next-line no-control-regex
    if (/[^\x21-\x7e]/.test(metin))
        return { ok: false, neden: 'E-posta adresinde yalnız İngilizce harf, rakam ve . _ - + işaretleri olabilir.' };
    const adres = metin.toLowerCase();
    const parca = adres.split('@');
    if (parca.length === 1)
        return { ok: false, neden: 'E-posta adresinde "@" işareti eksik. Örnek: ad@firma.com' };
    if (parca.length > 2)
        return { ok: false, neden: 'E-posta adresinde yalnız bir tane "@" olabilir.' };
    const [ad, alan] = parca;
    if (!ad)
        return { ok: false, neden: '"@" işaretinden önce ad kısmı eksik. Örnek: ad@firma.com' };
    if (!alan)
        return { ok: false, neden: '"@" işaretinden sonra alan adı eksik. Örnek: ad@firma.com' };
    if (!/^[a-z0-9._%+-]+$/.test(ad))
        return { ok: false, neden: 'Ad kısmında yalnız harf, rakam ve . _ - + işaretleri olabilir.' };
    if (ad.startsWith('.') || ad.endsWith('.') || ad.includes('..'))
        return { ok: false, neden: 'Ad kısmı nokta ile başlayamaz, bitemez; iki nokta yan yana olamaz.' };
    if (ad.length > 64 || adres.length > 254)
        return { ok: false, neden: 'E-posta adresi çok uzun.' };
    if (!alan.includes('.'))
        return { ok: false, neden: `Alan adı eksik: "${alan}" sonuna .com, .com.tr gibi bir uzantı gerekli.` };
    if (alan.startsWith('.') || alan.endsWith('.') || alan.includes('..'))
        return { ok: false, neden: 'Alan adında nokta yanlış yerde.' };
    const etiketler = alan.split('.');
    if (etiketler.some((e) => !/^[a-z0-9-]+$/.test(e) || e.startsWith('-') || e.endsWith('-'))) {
        return { ok: false, neden: 'Alan adında yalnız harf, rakam ve tire olabilir.' };
    }
    if (!/^[a-z]{2,}$/.test(etiketler[etiketler.length - 1]))
        return { ok: false, neden: 'Alan adının uzantısı geçersiz (örnek: .com, .com.tr).' };
    const dogru = ALAN_DUZELT[alan];
    if (dogru)
        return { ok: false, neden: `Alan adı yanlış yazılmış görünüyor: "${alan}".`, oneri: `${ad}@${dogru}` };
    return { ok: true, deger: adres, goster: adres };
}
/**
 * Telefonu YAZARKEN gruplar (giriş kutusu maskesi): 05321234567 → "0532 123 45 67", +905321234567 → "+90 532 123 45 67".
 * Yalnız görünümü düzenler, denetim yapmaz; yurt dışı numarasında kullanıcının yazımı korunur.
 */
export function telefonYazarken(ham) {
    if (/[^\d\s()+.\-]/.test(ham))
        return ham;
    const arti = ham.trimStart().startsWith('+');
    const d = ham.replace(/\D/g, '');
    const grup = (s) => [s.slice(0, 3), s.slice(3, 6), s.slice(6, 8), s.slice(8, 10)].filter(Boolean).join(' ');
    if (arti) {
        if (!d.startsWith('90'))
            return d.length <= 2 ? `+${d}` : ham.replace(/[^\d\s+]/g, '').replace(/\s+/g, ' ').slice(0, 22);
        const govde = d.slice(2).replace(/^0/, '').slice(0, 10);
        return govde ? `+90 ${grup(govde)}` : '+90';
    }
    if (d.startsWith('00'))
        return ham.replace(/[^\d\s]/g, '').replace(/\s+/g, ' ').slice(0, 22);
    if (d.startsWith('90') && d.length > 10)
        return `+90 ${grup(d.slice(2).slice(0, 10))}`;
    const sifir = d.startsWith('0');
    const govde = (sifir ? d.slice(1) : d).slice(0, 10);
    return `${sifir ? '0' : ''}${grup(govde)}`;
}
